// extracted by mini-css-extract-plugin
export default {"container":"Empty_container__9O9ne"};